export enum AdmFilterType {
  FLOOR = 'floor',
  TAG = 'tag',
  DATE = 'date'
}

export enum DateType {
  START_DATE,
  END_DATE
}

export const admFilterConfigs: AdmFilterConfig[] = [
  { type: AdmFilterType.FLOOR, label: 'Filter by floor(s)', formKey: 'floor', color: 'green', dataCy: 'floor' },
  { type: AdmFilterType.TAG, label: 'Filter by tag(s)', formKey: 'tag', color: 'red', dataCy: 'tag' },
  { type: AdmFilterType.DATE, label: 'Filter by date', formKey: 'date', color: 'grey', dataCy: 'date' }
];

export interface AdmFilterConfig {
  type: AdmFilterType;
  label: string;
  formKey: string;
  color: string;
  dataCy: string;
}
